import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImportedStatement = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2.8335 1.4375H9.72705C9.95905 1.4375 10.1821 1.52936 10.3462 1.69336L13.0776 4.4248C13.2416 4.58889 13.3335 4.81195 13.3335 5.04395V13.6875C13.3335 14.1707 12.9417 14.5625 12.4585 14.5625H2.8335C2.35025 14.5625 1.9585 14.1707 1.9585 13.6875V2.3125C1.9585 1.82925 2.35025 1.4375 2.8335 1.4375Z",
		stroke: "currentColor",
		strokeWidth: .875
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.07959 8.11667L6.71292 9.75L10.2129 6.25",
		stroke: "currentColor",
		strokeWidth: .875,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgImportedStatement;
